import { render } from "./ServiceIndex.vue?vue&type=template&id=56cff984&scoped=true"
import script from "./ServiceIndex.vue?vue&type=script&lang=js"
export * from "./ServiceIndex.vue?vue&type=script&lang=js"

import "./ServiceIndex.vue?vue&type=style&index=0&id=56cff984&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cff984"]])

export default __exports__